import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-05jurassic_verticalalign_bottom",
  "use": "icon-05jurassic_verticalalign_bottom-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-05jurassic_verticalalign_bottom\"><path d=\"M64 896h896v64H64z\" fill=\"#727272\" /><path d=\"M192 832V64h256v768z\" fill=\"#497CAD\" /><path d=\"M576 832V320h256v512z\" fill=\"#B3B3B3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol